// extracted by mini-css-extract-plugin
export default {"container":"SortByDropdown_container__+bQ1A","categorySingle":"SortByDropdown_categorySingle__fA+UJ"};